export const URL_LOGIN = '/user/login';
export const LOCAL_STORAGE = {
  redNum: 'redNum',
  version: 'version',
  tokenInfo: 'tokenInfo',
  userInfo: 'userInfo',
  personalConfig: 'personalConfig',
  ottBoardLastQuery: 'ottBoardLastQuery',
  printPreviewCompact: 'printPreviewCompact',
  printPreviewColWidth: 'printPreviewColWidth',
};

//   面料类型枚举
export const UNIT_TYPE = {
  1: 'kg',
  2: '米',
  3: '码',
  4: 'kg',
  5: '米',
  6: '米',
  7: '米',
};

//   面料类型下拉框选项
export const FABRIC_TYPE_OPTION = [
  { label: '针织', value: 1 },
  { label: '梭织', value: 2 },
  { label: '牛仔', value: 3 },
  { label: '毛织', value: 4 },
  { label: '羽绒', value: 5 },
  { label: '雪纺', value: 6 },
  { label: '其他', value: 7 },
];

// 样板状态颜色
export const STATUS_CLASS = [
  { status_desc: '新开发1', status: 'new' },
  { status_desc: '已废图', status: 'obsolete-image' },
  { status_desc: '打板中', status: 'patterning' },
  { status_desc: '已打板', status: 'patterned' },
  { status_desc: '已废板', status: 'obsolete-template' },
  { status_desc: '可生产', status: 'producible' },
  { status_desc: '已下单', status: 'already-ordered' },
];

//   单位类型-空差显示
export const UNIT_GAP = {
  米: '%',
  码: '%',
  kg: 'kg',
};

export const IS_OPEN_SENTRY =
  process.env.NODE_ENV === 'production' && API_URL === 'https://api.yizheyun.com';

// 打开新的弹窗
export const WINDOW_TARGET_ROUTES_NAME: string[] = [
  //   '样板管理',
  //   '生产订单',
  //   '采购列表',
  '提前采购',
  //   '跟单管理',
  //   '物料仓库管理',
  //   '成衣入库',
];

export const DEFALULT_IMG =
  'https://dafeiimg.huole.cn/yizhe/obs/202207/26/165879925262df44948e26d.png';
// 生产单类型
export const PRODUCTION_VALUE_ENUM = {
  firstSingle: 1,
  returnSingle: 2,
  order: 3,
};

export const PRODUCTION_TYPE_OPTION = [
  { label: '首单', value: 1 },
  { label: '返单', value: 2 },
  { label: '订单', value: 3 },
  //   { label: '合并单', value: -1 },
];

// 返修状态
export const STATUS_REPAIR_OPTION = [
  { label: '未返修', value: 1 },
  { label: '部分返修', value: 2 },
  { label: '全部返修', value: 3 },
];

// 回货状态
export const STATUS_RETURN_OPTION = [
  { label: '未回货', value: 1 },
  { label: '部分回货', value: 2 },
  { label: '全部回货', value: 3 },
];

// 报损状态
export const STATUS_DAMAGED_OPTION = [
  { label: '未报损', value: 1 },
  { label: '已报损', value: 3 },
  // { label: '已删除', value: 3 },
];

// 按明细核对状态
export const PAID_STATUS = {
  WEI_HE_DUI: 1,
  YI_HE_DUI: 3,
  YI_CHE_XIAO: 4,
};

export const PAID_STATUS_OPTION = [
  { label: '待核对', value: 1 },
  { label: '已核对', value: 3 },
  { label: '已撤销', value: 4 },
];
// 顶部header高度
export const PAGE_HEADER_HEIGHT = 56;

// 默认展开的菜单路由
export const MENU_OPEN_ROUTES = ['/board'];

// 打印中心下的页面
export const PRINT_CENTER_ROUTES = '/print-center/';

// 打印中心来源
export const PRINT_CENTER_SOURCE = ['baoban'];
